'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var spacings = exports.spacings = {
    xxSmall: { web: '4px', mobile: '4px' },
    xSmall: { web: '8px', mobile: '7px' },
    mSmall: { web: '12px', mobile: '11px' },
    small: { web: '16px', mobile: '14px' },
    medium: { web: '24px', mobile: '22px' },
    large: { web: '32px', mobile: '29px' },
    mxLarge: { web: '38px', mobile: '34px' },
    xLarge: { web: '48px', mobile: '44px' },
    xxLarge: { web: '64px', mobile: '59px' },
    xxxLarge: { web: '80px', mobile: '72px' }
};
//# sourceMappingURL=spacings.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-makeup/dist/design-system/config/data/spacings.js
// module id = 960
// module chunks = 0